module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0bf5e11621789f54a2ffbd7df4876ab2.png";